module.exports = __webpack_public_path__ + "static/img/faPath5.46abfae7.gif";